import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Remove undefined values from an object (shallow).
 * Firestore does not accept undefined values - use this before writes.
 * 
 * @example
 * stripUndefined({ a: 1, b: undefined, c: null }) // { a: 1, c: null }
 */
export function stripUndefined<T extends Record<string, unknown>>(obj: T): Partial<T> {
  return Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v !== undefined)
  ) as Partial<T>;
}
